import apiClient from './api';
import spazioService from './spazioService';

let cachedProfile = null;

// La richiesta in volo, condivisa da tutti quelli che chiedono il profilo mentre non e' ancora
// arrivato. A freddo partono insieme la guardia del router, il menu e la barra in alto: senza
// questa, tre GET /account/me identiche, e ognuna fa riscrivere al server l'ultimo spazio usato.
// Stesso schema di preferencesService.
let profilePromise = null;

const userService = {
  async getProfile() {
    if (cachedProfile) return cachedProfile;
    if (profilePromise) return profilePromise;

    profilePromise = apiClient.get('/account/me')
      .then(response => {
        cachedProfile = response.data.data;
        // Il server dice sempre su quale spazio ci ha messo: la copia locale si allinea qui,
        // cosi' l'intestazione X-Spazio delle richieste successive e' esplicita e non
        // dipende piu' dal ripiego "ultimo spazio usato".
        spazioService.allinea(cachedProfile?.spazioAttivo);
        profilePromise = null;
        return cachedProfile;
      })
      .catch(e => {
        profilePromise = null;
        console.error('Failed to load user profile:', e);
        return null;
      });

    return profilePromise;
  },

  clearCache() {
    cachedProfile = null;
    profilePromise = null;
  },

  async getRoles() {
    const profile = await this.getProfile();
    return profile?.roles || [];
  },

  async getFeatures() {
    const profile = await this.getProfile();
    return profile?.features || {};
  },

  /** Gli spazi di lavoro di cui questa persona fa parte. Vuoto = ha solo inviti da accettare. */
  async getSpazi() {
    const profile = await this.getProfile();
    return profile?.spazi || [];
  },

  /** Gli inviti ancora da accettare: servono a farli trovare anche a chi non ha ricevuto il link. */
  async getInviti() {
    const profile = await this.getProfile();
    return profile?.inviti || [];
  },

  /** Identificativo dello spazio su cui il server ci sta facendo lavorare, o null. */
  async getSpazioAttivo() {
    const profile = await this.getProfile();
    return profile?.spazioAttivo || null;
  },

  /** Il ruolo dentro lo spazio attivo (TITOLARE, AMMINISTRATORE, ...), o null se non siamo in nessuno spazio. */
  async getRuolo() {
    const profile = await this.getProfile();
    return profile?.ruolo || null;
  },

  async hasRole(role) {
    const roles = await this.getRoles();
    return roles.includes(role);
  },

  async hasFeature(feature) {
    const features = await this.getFeatures();
    return features[feature] === true;
  },

  async isSuperAdmin() {
    return this.hasRole('SUPER_ADMIN');
  },

  async isBetaTester() {
    return this.hasRole('BETA_TESTER');
  },
};

export default userService;
